module.exports = __webpack_public_path__ + "static/youtube-icon-9a59817eac70327b226ee3fe81f200c5.png";